import * as React from 'react';
import {
    Controller,
    MainMenu,
    Toolbar,
} from '@tencent/workbench';
import { TailorPicShapeFeature } from './tailor-pic-shape-feature';
import {
    config, MENU_CONFIGS, TOOLBAR_ITEMS,
} from './config';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class TailorPicShapeController {
    public constructor(private readonly feature: TailorPicShapeFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    public getPcBtnDropdownContent() {
        return <MainMenu align="left" name={config.id} mode="menu" dropdownContentStyle={{ padding: 0 }}/>;
    }

    @Toolbar(config.id, 'onDropdownVisibleChange')
    public onDropdownVisibleChange(visible: boolean) {
        this.feature.updateDropdownVisible(visible, config.id);
    }
}
